// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e9j9","title":"styles_title__2fg3S"};